import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

export const BIN_STATUS_LEGEND_WITH_LOCKED = [
  { color: '#fbbf24', label: 'Assigned' },
  { color: '#60a5fa', label: 'Hold' },
  { color: '#34d399', label: 'Stocked' },
  { color: '#f87171', label: 'Deactivate' },
  { color: '#a78bfa', label: 'Locked' },
];

export const BIN_STATUS_LEGEND = BIN_STATUS_LEGEND_WITH_LOCKED.filter(
  (item) => item.label !== 'Locked'
);

const BinStatusLegend = ({
  items,
  onItemClick,
  activeLabel,
  className,
  variant = 'bar',
}) => {
  const pills = items.map((item) => {
    const isActive = activeLabel === item.label;
    const Tag = onItemClick ? 'button' : 'span';

    return (
      <Tag
        key={item.label}
        type={onItemClick ? 'button' : undefined}
        className={[
          'bin-status-legend__pill',
          onItemClick ? 'is-clickable' : '',
          isActive ? 'is-active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onItemClick ? (event) => onItemClick(event, item.label) : undefined}
      >
        <span
          className="bin-status-legend__dot"
          style={{ backgroundColor: item.color }}
          aria-hidden="true"
        />
        <span className="bin-status-legend__label">{item.label}</span>
      </Tag>
    );
  });

  if (variant === 'inline') {
    return (
      <div
        className={['bin-status-legend', 'bin-status-legend--inline', className]
          .filter(Boolean)
          .join(' ')}
      >
        {pills}
      </div>
    );
  }

  return (
    <div className={['bin-status-legend', className].filter(Boolean).join(' ')}>
      {pills}
    </div>
  );
};

BinStatusLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onItemClick: PropTypes.func,
  activeLabel: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['bar', 'inline']),
};

export default BinStatusLegend;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/BinStatusLegend.jsx